import { render, staticRenderFns } from "./InfoOffer.vue?vue&type=template&id=0c94fb2c&scoped=true&"
import script from "./InfoOffer.vue?vue&type=script&lang=js&"
export * from "./InfoOffer.vue?vue&type=script&lang=js&"
import style0 from "./InfoOffer.vue?vue&type=style&index=0&id=0c94fb2c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c94fb2c",
  null
  
)

export default component.exports